import script from "./ItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemList.vue?vue&type=script&setup=true&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=cb1b9b68&scoped=true&lang=scss"

import exportComponent from "E:\\work9\\wzbz_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb1b9b68"]])

export default __exports__